import http from './http';
import { version } from './version';
const prefix = `${version}/common`;

export async function getCode(param) {
  return http.post(prefix + `/getCode?code=${param}`);
}

export async function getCodeAll(param) {
  return http.post(prefix + `/getCodeAll`, param);
}

export async function getCodeDetail(param) {
  return http.post(prefix + `/getCodeDetail?code=${param}`);
}

export async function insertCode(param) {
  return http.post(prefix + `/insertCode`, param);
}

export async function updateCode(param) {
  return http.post(prefix + `/updateCode`, param);
}
